<span class="p-float-label p-inputtext">
  <div *ngIf="optionsLoaded" class="p-inputwrapper-filled flex align-items-center h-full">
    <ng-container *ngFor="let entry of options">
      <i
        [class]="(entry.icon ? entry.icon : 'pi pi-question') + ' iconEntry'"
        [pTooltip]="entry.name"
        [style]="entry.active ? 'color: ' + entry.color + '; background: #E0E0E0; border-radius: 4px' : ''"
        (click)="onIconSelected(entry)"
      ></i>
    </ng-container>
  </div>
  <div *ngIf="!optionsLoaded" class="p-inputwrapper-filled">
    <i class="pi pi-spinner iconEntry iconSpinner"></i>
  </div>

  <label for="float-input">{{ field.header }}</label>
</span>
